import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState } from 'react';

interface ScoreUpdateDialogProps {
  open: boolean;
  team1Name: string;
  team2Name: string;
  currentTeam1Goals?: number;
  currentTeam2Goals?: number;
  onClose: () => void;
  onConfirm: (team1Goals: number, team2Goals: number) => void;
}

export const ScoreUpdateDialog = ({
  open,
  team1Name,
  team2Name,
  currentTeam1Goals,
  currentTeam2Goals,
  onClose,
  onConfirm,
}: ScoreUpdateDialogProps) => {
  const [team1Goals, setTeam1Goals] = useState<number>(currentTeam1Goals ?? 0);
  const [team2Goals, setTeam2Goals] = useState<number>(currentTeam2Goals ?? 0);

  const handleTeam1GoalsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value, 10);
    setTeam1Goals(isNaN(value) ? 0 : Math.max(0, value));
  };

  const handleTeam2GoalsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value, 10);
    setTeam2Goals(isNaN(value) ? 0 : Math.max(0, value));
  };

  const handleConfirm = () => {
    onConfirm(team1Goals, team2Goals);
  };

  const isSaveDisabled = team1Goals === currentTeam1Goals && team2Goals === currentTeam2Goals;

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth="sm">
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Edytuj wynik
        <IconButton aria-label="close" onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1">Wprowadź nowy wynik:</Typography>
        <TextField
          fullWidth
          margin="dense"
          type="number"
          label={team1Name}
          value={team1Goals}
          onChange={handleTeam1GoalsChange}
          onFocus={(e) => {
            e.target.select();
          }}
        />
        vs.
        <TextField
          fullWidth
          margin="dense"
          type="number"
          label={team2Name}
          value={team2Goals}
          onChange={handleTeam2GoalsChange}
          onFocus={(e) => {
            e.target.select();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleConfirm} disabled={isSaveDisabled}>
          Zapisz
        </Button>
        <Button variant="outlined" color="error" onClick={onClose}>
          Anuluj
        </Button>
      </DialogActions>
    </Dialog>
  );
};
